module.exports = __webpack_public_path__ + "668f3430bcdbe75f59efd32ba08ba635.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/assets/images/icons/canada_icon.png
// module id = 1225
// module chunks = 0